import { render, staticRenderFns } from "./Deprecate.vue?vue&type=template&id=178ad3c6&scoped=true"
import script from "./Deprecate.vue?vue&type=script&lang=js"
export * from "./Deprecate.vue?vue&type=script&lang=js"
import style0 from "./Deprecate.vue?vue&type=style&index=0&id=178ad3c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178ad3c6",
  null
  
)

export default component.exports